// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-content {
  overflow-x: auto;
}

.page-header .page-header-left {
  width: 100%;
  align-items: center;
}
.page-header .page-header-left .facility-select {
  width: 400px;
  margin-bottom: 0 !important;
}
.page-header .page-header-left .facility-select .react-select__control {
  height: 44px;
}
.page-header .page-header-left .facility-select .react-select__single-value {
  overflow: visible;
}
.page-header .page-header-left .total-house-info {
  margin-left: 16px;
  color: #7f56d9;
  height: 100%;
  display: flex;
  align-items: end;
}
.page-header .page-header-left .total-house-info p {
  line-height: 24px;
}
.page-header .page-header-right {
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
}
.page-header .page-header-right .today-date-div {
  width: max-content !important;
}
.page-header .page-header-right .buttons-wrapper {
  gap: 16px;
}
.page-header .page-header-right .print-btn,
.page-header .page-header-right .notes-btn {
  align-items: center;
}
.page-header .page-header-right .print-btn:disabled,
.page-header .page-header-right .notes-btn:disabled {
  background-color: #fff !important;
  color: #dadee4 !important;
}
.page-header .page-header-right .print-btn:disabled svg path,
.page-header .page-header-right .notes-btn:disabled svg path {
  fill: #dadee4;
}

.page-content {
  overflow-y: auto;
}
.page-content .empty {
  width: 100%;
  border: 1px solid #eaecf0;
  padding: 78px 20px;
  border-radius: 10px;
}
.page-content .empty .empty-title {
  font-weight: 600;
  font-size: 18px;
}
.page-content .unit-tables-wrapper {
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  width: fit-content;
  margin-top: 10px;
}

.isTablet .page-header-left {
  display: block;
  width: 340px;
}
.isTablet .page-header-left .facility-select {
  width: 340px;
  max-width: 340px;
}
.isTablet .page-header-left .total-house-info {
  height: unset;
  margin-left: 0;
  margin-top: 8px;
}
.isTablet .page-header-left .total-house-info .total-house-info-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.isTablet .page-header-right .today-date-div {
  margin-right: 0;
}

.isMobile:not(.isTablet) .page-wrapper {
  padding: 13px 24px;
}
.isMobile:not(.isTablet) .page-header {
  flex-direction: column-reverse;
}
.isMobile:not(.isTablet) .page-header-left {
  margin-top: 16px;
  display: block;
  width: 100%;
}
.isMobile:not(.isTablet) .page-header-left .facility-select {
  width: 100%;
}
.isMobile:not(.isTablet) .page-header-left .total-house-info {
  height: unset;
  margin-left: 0;
  margin-top: 8px;
}
.isMobile:not(.isTablet) .page-header-left .total-house-info .total-house-info-wrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.isMobile:not(.isTablet) .page-header-right {
  justify-content: space-between;
}
.isMobile:not(.isTablet) .page-header-right .today-date-div {
  margin-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/bedboard/styles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAGE;EACE,WAAA;EACA,mBAAA;AAAJ;AAEI;EACE,YAAA;EACA,2BAAA;AAAN;AAEM;EACE,YAAA;AAAR;AAGM;EACE,iBAAA;AADR;AAKI;EACE,iBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAHN;AAKM;EACE,iBAAA;AAHR;AAQE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AANJ;AAQI;EACE,6BAAA;AANN;AASI;EACE,SAAA;AAPN;AAUI;;EAEE,mBAAA;AARN;AAUM;;EACE,iCAAA;EACA,yBAAA;AAPR;AAUU;;EACE,aAAA;AAPZ;;AAeA;EACE,gBAAA;AAZF;AAcE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAZJ;AAaI;EACE,gBAAA;EACA,eAAA;AAXN;AAeE;EACE,aAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AAbJ;;AAkBE;EACE,cAAA;EACA,YAAA;AAfJ;AAiBI;EACE,YAAA;EACA,gBAAA;AAfN;AAkBI;EACE,aAAA;EACA,cAAA;EACA,eAAA;AAhBN;AAkBM;EACE,aAAA;EACA,WAAA;EACA,8BAAA;AAhBR;AAsBI;EACE,eAAA;AApBN;;AA0BE;EACE,kBAAA;AAvBJ;AA0BE;EACE,8BAAA;AAxBJ;AA2BE;EACE,gBAAA;EACA,cAAA;EACA,WAAA;AAzBJ;AA2BI;EACE,WAAA;AAzBN;AA4BI;EACE,aAAA;EACA,cAAA;EACA,eAAA;AA1BN;AA4BM;EACE,aAAA;EACA,WAAA;EACA,8BAAA;AA1BR;AA+BE;EACE,8BAAA;AA7BJ;AA8BI;EACE,eAAA;AA5BN","sourcesContent":[".page-content {\n  overflow-x: auto;\n}\n\n.page-header {\n  .page-header-left {\n    width: 100%;\n    align-items: center;\n\n    .facility-select {\n      width: 400px;\n      margin-bottom: 0 !important;\n\n      .react-select__control {\n        height: 44px;\n      }\n\n      .react-select__single-value {\n        overflow: visible;\n      }\n    }\n\n    .total-house-info {\n      margin-left: 16px;\n      color: #7f56d9;\n      height: 100%;\n      display: flex;\n      align-items: end;\n\n      p {\n        line-height: 24px;\n      }\n    }\n  }\n\n  .page-header-right {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 600;\n\n    .today-date-div {\n      width: max-content !important;\n    }\n\n    .buttons-wrapper {\n      gap: 16px;\n    }\n\n    .print-btn,\n    .notes-btn {\n      align-items: center;\n\n      &:disabled {\n        background-color: #fff !important;\n        color: #dadee4 !important;\n\n        svg {\n          path {\n            fill: #dadee4;\n          }\n        }\n      }\n    }\n  }\n}\n\n.page-content {\n  overflow-y: auto;\n\n  .empty {\n    width: 100%;\n    border: 1px solid #eaecf0;\n    padding: 78px 20px;\n    border-radius: 10px;\n    .empty-title {\n      font-weight: 600;\n      font-size: 18px;\n    }\n  }\n\n  .unit-tables-wrapper {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 16px;\n    width: fit-content;\n    margin-top: 10px;\n  }\n}\n\n.isTablet {\n  .page-header-left {\n    display: block;\n    width: 340px;\n\n    .facility-select {\n      width: 340px;\n      max-width: 340px;\n    }\n\n    .total-house-info {\n      height: unset;\n      margin-left: 0;\n      margin-top: 8px;\n\n      .total-house-info-wrapper {\n        display: flex;\n        width: 100%;\n        justify-content: space-between;\n      }\n    }\n  }\n\n  .page-header-right {\n    .today-date-div {\n      margin-right: 0;\n    }\n  }\n}\n\n.isMobile:not(.isTablet) {\n  .page-wrapper {\n    padding: 13px 24px;\n  }\n\n  .page-header {\n    flex-direction: column-reverse;\n  }\n\n  .page-header-left {\n    margin-top: 16px;\n    display: block;\n    width: 100%;\n\n    .facility-select {\n      width: 100%;\n    }\n\n    .total-house-info {\n      height: unset;\n      margin-left: 0;\n      margin-top: 8px;\n\n      .total-house-info-wrapper {\n        display: flex;\n        width: 100%;\n        justify-content: space-between;\n      }\n    }\n  }\n\n  .page-header-right {\n    justify-content: space-between;\n    .today-date-div {\n      margin-right: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
